import { combineReducers } from '@reduxjs/toolkit';
import { authSlice } from './auth';
import { searchSlice } from './search';
import { accountSlice } from './account';
import { emailConfigSlice } from './emailConfig';
import { loginHistorySlice } from './loginHistory';
import { logSlice } from './log';
import { apiRoleMappingSlice } from './apiRoleMapping';
import { menuItemSlice } from './menuItem';
import { boPhanSlice } from './boPhan';
import { teamSlice } from './team';
import { nhanVienSlice } from './nhanVien';
import { quyTrinhSlice } from './quyTrinh';
import { projectSlice } from './project';
import { khoaSlice } from './khoa';
import { linhvucSlice } from './linhvuc';
import { loaiyeucauSlice } from './loaiyeucau';
import { hoTroSlice } from './hotro';
import { yeuCauSlice } from './yeucau'; 
import { nguoiDungSlice } from './nguoidung';
import { projectStepSlice } from './projectStep';
import { congViecSlice } from './congViec';
import taskAssignmentReducer from './taskAssignment';
import { nhiemVuKhacSlice } from './nhiemvukhac';
import { congViecKhacSlice } from './congvieckhac';
import { nhiemVuCaNhanSlice } from './nhiemvucanhan';
import thongKeReducer from './thongke';
import nguoiPhoiHopReducer from './nguoiphoihop';
import { baoCaoSlice } from './baocao';
import { homeSlice } from './home';
import quanLyCongViecTongHopReducer from './quanLyCongViecTongHop';
const rootReducer = combineReducers({
    auth: authSlice.reducer,
    search: searchSlice.reducer,
    account: accountSlice.reducer,
    emailConfig: emailConfigSlice.reducer,
    loginHistory: loginHistorySlice.reducer,
    log: logSlice.reducer,
    apiRoleMapping: apiRoleMappingSlice.reducer,
    menuItem: menuItemSlice.reducer,
    boPhan: boPhanSlice.reducer,
    team: teamSlice.reducer,
    nhanVien: nhanVienSlice.reducer,
    khoa: khoaSlice.reducer,
    quyTrinh: quyTrinhSlice.reducer,
    project: projectSlice.reducer,  
    projectStep: projectStepSlice.reducer,
    linhvuc: linhvucSlice.reducer,
    loaiyeucau: loaiyeucauSlice.reducer,
    hoTro: hoTroSlice.reducer,
    yeuCau: yeuCauSlice.reducer,   
    nguoiDung: nguoiDungSlice.reducer,
    congViec: congViecSlice.reducer,
    taskAssignment: taskAssignmentReducer,
    nhiemVuKhac: nhiemVuKhacSlice.reducer,
    congViecKhac: congViecKhacSlice.reducer,
    nhiemVuCaNhan: nhiemVuCaNhanSlice.reducer,
    thongKe: thongKeReducer,
    nguoiPhoiHop: nguoiPhoiHopReducer,
    baocao: baoCaoSlice.reducer,
    home: homeSlice.reducer,
    quanLyCongViecTongHop: quanLyCongViecTongHopReducer,
});

export default rootReducer;